export default class DataService {
 
  parseDate(ignored, value) {
//    console.log("entrou1")
     if (typeof value !== "string") {
     
      return value;
    } 
    const isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
    if (isoDateRegex.exec(value)) {
      console.log("entrou data",value)
     let tmp = new Date(value);
      console.log(tmp)
      return tmp;
    }

    // isIsoDate(value) {
    //   const isoDateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
  
    //   return isoDateRegex.exec(value);
    // }
  
   // return value;
    
  } 
}
